var scaleToFontSize = function scaleToFontSize(scale) {
  var curFontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  return curFontSize * Math.abs(scale);
};

export { scaleToFontSize as default };
